import(/* webpackMode: "eager" */ "/home/coder/pubky-app-play/src/app/(feeds)/layout.tsx");
